import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SimCardIcon from '@material-ui/icons/SimCard';
import GroupIcon from '@material-ui/icons/Group';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { Profile, SidebarNav } from './components';

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 180,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, history, ...rest } = props;

  const classes = useStyles();

  const pages = [
    {
      title: 'Users',
      href: '/admin/users',
      icon: <GroupIcon />
    },
    {
      title: 'Cards',
      href: '/admin/cards',
      icon: <SimCardIcon />
    },
    {
      title: 'Orders',
      href: '/admin/orders',
      icon: <ShoppingCartIcon />
    },
    {
      title: 'Payments',
      href: '/admin/payments',
      icon: <AccountBalanceIcon />
    },
    {
      title: 'Settings',
      href: '/admin/settings',
      icon: <MoreVertIcon />
    },
    {
      title: 'Logout',
      href: '/admin/logout',
      icon: <InputIcon />
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav history={history} className={classes.nav} pages={pages} />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
